module.exports = __webpack_public_path__ + "img/advmap.932188d8.jpg";